import React from "react"
import { InteractiveRenderer } from '@bittnerdevelopmentgroup/interactive-builder'
import { Page, TaskTest, Storage } from '@bittnerdevelopmentgroup/interactive'

export default function PartialTest({data}) {
  return <InteractiveRenderer storageKey="parent" fullWidth data={data}>
    <InteractiveRenderer storageKey="page0" data={data.panels[0]}/>
    <Page>
      This is a test page inserted between panels 0 and 1.
      <TaskTest state={Storage()} text="Complete"/>
    </Page>
    <InteractiveRenderer storageKey="page1" data={data.panels[1]}/>
    <InteractiveRenderer storageKey="page2" data={data.panels[2]}/>
    <InteractiveRenderer storageKey="page3" data={data.panels[3]}/>
  </InteractiveRenderer>
}